import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'data-card',
  templateUrl: './data-card.component.html',
  styleUrls: ['./data-card.component.scss']
})
export class DataCardComponent {

  @Input() dates;
  @Input() data;

  ngOnInit() {

    if (this.dates === undefined || this.data === undefined) {
      console.log('--- CARD DATA is missing data --- ');
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/data-cards/data-card/data-card.component.ts